import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Flame } from 'lucide-react';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const handleClick = () => {
    const target = document.getElementById('oferta');
    if (target) {
      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <AnimatePresence data-id="element-24">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 right-0 z-50 p-3 bg-dark/95 backdrop-blur-md border-t border-dark-border md:hidden" data-id="element-25">
          <div className="flex items-center justify-between gap-3 max-w-md mx-auto" data-id="element-26">
            <div className="flex flex-col leading-tight" data-id="element-27">
              <span className="text-[10px] text-gray-400 uppercase tracking-wider font-bold" data-id="element-28">
                Desde
              </span>
              <span className="text-lg font-display text-brand leading-none" data-id="element-29">
                $14.990
              </span>
            </div>
            <button onClick={handleClick} className="flex-1 bg-brand hover:bg-brand-light text-white font-display tracking-wider px-4 py-3 rounded-lg shadow-[0_0_20px_rgba(234,88,12,0.4)] flex items-center justify-center gap-2 text-lg uppercase" data-id="element-30">
              <Flame className="w-4 h-4 fill-current" data-id="element-31" />
              Ver Planes
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}